import * as React from 'react';

import { CustomSVGProps } from 'styles/theme';

export const Google = (props: CustomSVGProps) => (
    <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.643 13.2436C23.643 12.3927 23.5667 11.5745 23.4249 10.7891H12.123V15.4309H18.5812C18.303 16.9309 17.4576 18.2018 16.1867 19.0527V22.0636H20.0649C22.334 19.9745 23.643 16.8982 23.643 13.2436Z"
            fill="#4285F4"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1221 24.9739C15.3621 24.9739 18.0784 23.8994 20.0639 22.0666L16.1857 19.0557C15.1112 19.7757 13.7366 20.2012 12.1221 20.2012C8.99662 20.2012 6.35116 18.0903 5.40753 15.2539H1.39844V18.363C3.37298 22.2848 7.43117 24.9739 12.1221 24.9739Z"
            fill="#34A853"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.4085 15.2531C5.1685 14.5331 5.03214 13.764 5.03214 12.9731C5.03214 12.1822 5.1685 11.4131 5.4085 10.6931V7.58398H1.39941C0.586683 9.20398 0.123047 11.0367 0.123047 12.9731C0.123047 14.9094 0.586683 16.7422 1.39941 18.3622L5.4085 15.2531Z"
            fill="#FBBC05"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1221 5.74538C13.8839 5.74538 15.4657 6.35084 16.7093 7.53993L20.1512 4.09811C18.073 2.16175 15.3566 0.972656 12.1221 0.972656C7.43117 0.972656 3.37298 3.66175 1.39844 7.58357L5.40753 10.6927C6.35117 7.85629 8.99662 5.74538 12.1221 5.74538Z"
            fill="#EA4335"
        />
    </svg>
);
